<template>
    <div class="grid">
        <div class="box">
            <img src="../assets/images/staticPages/checkup_SanKart-450x300.jpg" alt="checkup_SanKart"
                 width="225"/>
            <a href="/санаторно-курортная-карта"
               class="link"><span>САНАТОРНО-КУРОРТНАЯ КАРТА</span></a>
        </div>
        <div class="box">
            <img src="../assets/images/staticPages/otd_prof.png" alt="otd_prof" width="225"/>
            <a href="/предварительные-медицинские-осмотры"
               class="link"><span>ПРЕДВАРИТЕЛЬНЫЕ МЕДОСМОТРЫ</span></a>
        </div>
        <div class="box">
            <img src="../assets/images/staticPages/spr_OsmAbit-450x300.jpg" alt="spr_OsmAbit" width="225"/>
            <a href="/медицинские-осмотры-для-абитуриенто"
               class="link"><span>МЕДОСМОТРЫ АБИТУРИЕНТОВ</span></a>
        </div>
        <div class="box">
            <img src="../assets/images/staticPages/spr_vjd-450x300.png" alt="spr_vjd" width="225"/>
            <a href="/медицинская-водительская-комиссия"
               class="link"><span>ДЛЯ ВОДИТЕЛЕЙ</span></a>
        </div>
        <div class="box">
            <img src="../assets/images/staticPages/galway-swimming-pool-membership-450x300.jpg"
                 alt="galway-swimming-pool-membership" width="225"/>
            <a href="/справка-в-бассейн"
               class="link"><span>СПРАВКА В БАССЕЙН</span></a>
        </div>
        <div class="box">
            <img src="../assets/images/staticPages/court-gavel-justice-450x300.jpg" alt="court-gavel-justice"
                 width="225"/>
            <a href="/освидетельствование-на-должность-су"
               class="link"><span>ОСВИДЕТЕЛЬСТВОВАНИЕ НА ДОЛЖНОСТЬ СУДЬИ</span></a>
        </div>
        <div class="box">
            <img src="../assets/images/staticPages/gostaina.jpg" alt="gostaina" width="225"/>
            <a href="/гостайн"
               class="link"><span>СПРАВКА НА ГОСТАЙНУ</span></a>
        </div>
        <div class="box">
            <img src="../assets/images/staticPages/crop-450x300.jpg" alt="crop" width="225"/>
            <a href="/справка-для-поступающих-на-государст"
               class="link"><span>СПРАВКА ДЛЯ ПОСТУПАЮЩИХ НА ГОСУДАРСТВЕННУЮ СЛУЖБУ</span></a>
        </div>
    </div>
</template>

<script>
export default {
    name: "RegistrationBlogs",
}
</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #006688;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 215px;
}

.box > img {
    width: 215px !important;
    height: 143px !important;
}

.box:first-child {
    margin: 0;
}

.grid {
    display: grid;
    grid-gap: 30px;
    grid-template-columns: repeat(auto-fill, 215px);
}

.link {
    color: black;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
    margin: 5px auto;
}

.link > span {
    border-bottom: 1px dotted #006688;
    font-size: 13px;
}

.left-30px {
    margin-left: 30px;
}

.table-state {
    color: #666;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    position: sticky;

    &.open {
        padding: 10px 12px;
        background: #006688;
        color: white;
        margin-bottom: 20px;
    }

    h3 {
        font-size: 18px;
        font-weight: normal;
    }

    h3:hover {
        color: #3156A3;
    }

    &.open h3:hover {
        color: white;
    }

    @media screen and (max-width: 510px) {
        font-size: 11px;
    }
    @media screen and (max-width: 768px) {
        top: 0;
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .4s, max-height .6s;
    max-height: 1000px;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
    max-height: 0;
}

</style>

